import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ComFunction from "../components/ComFunction";
import { isEmpty, GetExtension} from '../modules/appLibrary';


//---------------------------------------------------------------------
//  File Drop Zone
//---------------------------------------------------------------------
export default function DropZone(props) {
    const fnc = useRef();
    const styleRef = useRef();
    const targetflg = useRef(false);
    const ComFunc = React.forwardRef(ComFunction);

    const formstatus = useSelector(state => state.form.status);

    function handleClose() {
        props.onclose();
    }

    const onDragEnter = (e) => {
        if (e.target.id === "msg") {
            targetflg.current = true;
            return;
        }
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0 ) {
            styleRef.current.style.color = "#fff";
        }
    };
    const onDragLeave = (e) => {
        if (e.target.id === "msg") {
            targetflg.current = false;
            styleRef.current.style.color = "#fff";
        } else {
            if (targetflg.current) return;
            styleRef.current.style.color = "#000";
        }
    };
    const onDrop = (e) => {
        e.preventDefault();
        styleRef.current.style.color = "#fff";
        if (e.dataTransfer.files !== null && e.dataTransfer.files.length > 0) {
            if (e.dataTransfer.files.length > 10) {
                fnc.current.warnmsg("１度にアップロードできるのは１０ファイルまでです。");
                styleRef.current.style.color = "#000";
                e.dataTransfer.clearData();
                return;
            }
            let len = 0;
            let files = [];
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
                if (GetExtension(e.dataTransfer.files[i].name) === "") {
                    fnc.current.warnmsg("無効な形式のファイルが含まれています。");
                    styleRef.current.style.color = "#000";
                    e.dataTransfer.clearData();
                    return;
                }
                len += e.dataTransfer.files[i].size;
                files.push(e.dataTransfer.files[i]);
            }
            if (len > 10000000) {
                fnc.current.warnmsg("選択ファイルはアップロード可能なファイルサイズを超えています。");
                styleRef.current.style.color = "#000";
                e.dataTransfer.clearData();
                return;
            }
            //v1.4
            if (!props.localOnly && formstatus === "ENTRY FORM")
                onDropFile(files);
            else
                onLoadFile(files);
            e.dataTransfer.clearData();
        }
    };
    //v1.4
    function onLoadFile(files) {
        var data = {images:[], files:[]};
        for (let i = 0; i < files.length; i++) {
            if (files[i].type.startsWith('image/')) {
                const objectUrl = URL.createObjectURL(files[i]);
                var img = { filename: files[i].name, imageurl: objectUrl, fileinfo: files[i] };
                data.images.push(img);
            } else {
                var f = { filename: files[i].name, fileinfo: files[i] };
                data.files.push(f);
            }
        }
        if (!isEmpty(props.uploaded)) {
            props.uploaded(data);
        }
        handleClose();
   }
    function onDropFile(files) {
        let param = {
            "code": props.code,
            "count": files.length,
            "check": true
        };
        if (!isEmpty(props.controller)) {
            param["controller"] = props.controller;
        }
        for (let i = 0; i < files.length; i++) {
            param["file" + (i + 1).toString()] = files[i];
        }

        fnc.current.fileupload(props.actionurl.upload, param,
            {
                onSuccess: function (data) {
                    if (!isEmpty(props.uploaded)) {
                        props.uploaded(data);
                    }
                    fnc.current.success();
                    fnc.current.wait(false);
                    handleClose();
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    if (data.request === "") {
                        fnc.warnmessage(data.errDescription);
                        return;
                    }
                    let msg = ["アップロード済のファイルが存在します。上書きされますがよろしいですか？",
                        "対象ファイル:" + data.request];
                    param.check = false;
                    fnc.current.confmsg(msg, () => fileupload(param));
                }
            });
    }
    function fileupload(param) {
        fnc.current.fileupload(props.actionurl.upload, param,
            {
                onSuccess: function (data) {
                    if (!isEmpty(props.uploaded)) props.uploaded(data);
                    fnc.current.success();
                    fnc.current.wait(false);
                    handleClose();
                },
                errmsg: "アップロードに失敗しました"
            });
    }

    function RenderBody() {
        //if (!props.open || formstatus !== "ENTRY FORM") return null;
        if (!props.open || formstatus.indexOf("FORM") === -1) return null;      //v1.4
        return <div>
            <Dialog onClose={handleClose} open={true} fullWidth={true} maxWidth={'md'}>
                <DialogTitle>File Upload</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Container sx={{ width: '80%', pb: 5 }}>
                    <Box
                        onDragEnter={onDragEnter}
                        onDragLeave={onDragLeave}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={onDrop}
                        sx={{ bgcolor: '#cfe8fc', height: '70vh', pl: 15 }}
                        display="flex"
                        alignItems="center" >
                        <div
                            id="msg"
                            onDragEnter={onDragEnter}
                            onDragLeave={onDragLeave}
                            style={{ fontSize: 20 }}
                            ref={styleRef}>ここにファイルをDrag&Dropしてください</div>
                    </Box>
                </Container>
            </Dialog>
            <ComFunc ref={fnc} />
        </div>
    }
    return (
        <RenderBody />
    );
};
